import * as React from 'react';

export function Title({ children }: { children?: React.ReactNode }) {
  return (
    <div className="text-foreground text-[24px] font-bold leading-8 [font-family:Montserrat,Inter,system-ui,sans-serif]">
      {children}
    </div>
  );
}
